import { Icon, type IconComponent } from '@fountain/ripple/icon';
import React, { type FC } from 'react';

export const rippleModalHeaderIcon = (
  glyph: IconComponent,
): FC<{ color?: string | false }> => {
  const HeaderIcon: FC<{ color?: string | false }> = ({ color }) => (
    <Icon icon={glyph} size="md" color={color ? 'rose' : 'brand'} />
  );

  return HeaderIcon;
};
